/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import { DMUKLogo } from '@omnigenbiodata/ui';

import Footer from '../Footer';
import ROUTES from '../../../core/constants/routes.constants';
import { useStyles } from './component.styles';
import SideMenu from '../SideMenu';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

interface PortalLayoutProps {
  children: any;
}

function PortalLayout({ children }: PortalLayoutProps) {
  const classes = useStyles();
  const [isMenuOpenFlag, setIsMenuOpenFlag] = useState(false);

  const handleToggleMenu = (open: boolean) => (event: any) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setIsMenuOpenFlag(open);
  };

  return (
    <div css={classes.root} id="portalRoot">
      <Paper css={[classes.paper, classes.paperShaded]} elevation={4} id="paper">
        <Box mb={2}>
          <Toolbar disableGutters>
            <div style={{ flexGrow: 0 }}>
              <Hidden only="xs">
                <Link to={ROUTES.portal}>
                  <DMUKLogo size="xs" />
                </Link>
              </Hidden>
              <Hidden smUp>
                <Link to={ROUTES.portal}>
                  <DMUKLogo size="xs" />
                </Link>
              </Hidden>
            </div>
            <div style={{ flexGrow: 1, textAlign: 'left' }}>
              <Typography variant="h4" component="h1" align="center" py={0} mx={3} textAlign={'left'}>
                Study Portal
              </Typography>
            </div>
            <IconButton
              onClick={handleToggleMenu(true)}
              edge="end"
              css={classes.appBarHamburger}
              data-testid="menu-btn"
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </Box>
        <SideMenu isOpen={isMenuOpenFlag} onToggle={handleToggleMenu} />
        <Fade in timeout={500}>
          <div css={classes.content}>{children}</div>
        </Fade>
        <Footer />
      </Paper>
    </div>
  );
}

export default PortalLayout;
